import { useQuery } from "@tanstack/react-query";
import { getAllPosts } from "@/api/post";

export const usePosts = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ["blogs", "paginated", params],
    queryFn: () => getAllPosts(params),
    ...options,
  });
};
